import classNames from 'classnames'

import FooterList from './FooterList'
import FooterInfoStrip from './FooterInfoStrip'
import logo from 'shared/assets/logoFooter.svg'

import styles from '../styles/footer.module.scss'

const Footer = ({ columns = [], brandLogo }) => (
    <>
        <div className={classNames('container-fluid', styles.footerContainer)}>
            <div className={classNames('row', styles.footerRow)}>
                <div className="col-sm-11">
                    <div className="row">
                        {columns.map((column, index) => (
                            <FooterList key={index} {...column} />
                        ))}
                    </div>
                </div>
            </div>
            <div className={styles.logo}>
                <img src={brandLogo || logo} alt="IndigoNeo" />
            </div>
        </div>
        <FooterInfoStrip />
    </>
)

export default Footer
